import { ApprovalFlows } from '@mint-sdk/api-approval-flows';

const useUpdateFlowMutation = () => {
  return ApprovalFlows.updateFlow();
};

export default useUpdateFlowMutation;
